export interface DurationOption {
  label: string;
  months: number | undefined;
}

export const DURATION_OPTIONS: DurationOption[] = [
  { label: "No Minimum", months: undefined },
  { label: "3 months", months: 3 },
  { label: "6 months", months: 6 },
  { label: "1 year", months: 12 },
  { label: "1.5 years", months: 18 },
  { label: "2 years", months: 24 },
  { label: "3 years", months: 36 },
  { label: "5 years", months: 60 },
  { label: "7 years", months: 84 },
  { label: "10 years", months: 120 },
  { label: "15 years", months: 180 },
  { label: "20 years", months: 240 },
  { label: "25 years", months: 300 },
];

export const DURATION_LABELS: Record<number, string> = Object.fromEntries(
  DURATION_OPTIONS.filter((o) => o.months != null).map((o) => [o.months!, o.label]),
);
